import { MessageSquare, Image, Settings } from 'lucide-react';

const ModernToolIcon = ({ iconSrc, altText, size = 'md', className = '' }) => {
  // Definindo tamanhos
  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-20 h-20',
    lg: 'w-28 h-28'
  };
  
  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      {/* Container externo para sombra */}
      <div className={`relative ${sizeClasses[size]} rounded-2xl bg-gradient-to-br from-gray-50 to-gray-200 p-0.5 shadow-lg`}>
        {/* Container interno para o ícone */}
        <div className="absolute inset-0 bg-white rounded-2xl overflow-hidden flex items-center justify-center">
          {/* Brilho de destaque */}
          <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white to-white opacity-50"></div>
          
          {/* Ícone */}
          <img
            src={iconSrc}
            alt={altText}
            className={`${sizeClasses[size]} object-fit drop-shadow-md`}
          />
        </div>
      </div>
    </div>
  );
};

// Componente de card para exibição de ferramenta na lista de seleção
const ToolCard = ({ tool, onClick }) => {
  // Renderiza o ícone apropriado com base no tipo de saída da ferramenta
  const renderToolIcon = (outputType) => {
    switch (outputType) {
      case 'audio':
        return <MessageSquare className="w-8 h-8 text-blue-500" />;
      case 'image':
        return <Image className="w-8 h-8 text-purple-500" />;
      default:
        return <Settings className="w-8 h-8 text-gray-500" />;
    }
  };

  return (
    <div 
      className="border rounded-lg p-4 cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-colors flex items-start"
      onClick={() => onClick(tool)}
    >
      {tool.provider_icon ? (
        <ModernToolIcon 
            iconSrc={tool.provider_icon} 
            altText={tool.provider} 
            size="md"
            className="mr-3"
        />
      ) : (
        renderToolIcon(tool.output_type)
      )}
      <div className="flex-1">
        <h5 className="font-medium text-gray-900">{tool.name}</h5>
        <p className="text-xs text-gray-600 mt-1 line-clamp-2">{tool.description}</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {tool.provider && (
            <span className="inline-block px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-full">
              {tool.provider_title}
            </span>
          )}
          {tool.tags && tool.tags.slice(0, 2).map((tag, i) => (
            <span key={i} className="bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded-full">
              {tag}
            </span>
          ))}
          {tool.tags && tool.tags.length > 2 && (
            <span className="bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full">
              +{tool.tags.length - 2}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ToolCard;